export default "/images/d52b534f57e8d2ad716aa525d88a4374.avif";